export default "__VITE_ASSET__DByktE32__"